const getFlightMinutes = (timeString) => {
    const date = new Date(timeString);
    return date.getMinutes();
}

export default getFlightMinutes;